export default __webpack_public_path__ + "static/media/burn.f120fb90.svg";